import React from "react";
import { Content } from "../../components/Containers";
import { useAuth } from "../../context/AuthContext";


const Home = () => {
  const { user } = useAuth();

  return (
    <>
      <Content>
        <div className="flex flex-row justify-evenly gap-8 pb-8 mb-6">
          <div className="text-white text-3xl">
            {`Bem vindo, ${user.name}`}
          </div>
        </div>
      </Content>
    </>
  );
};

export default Home;
